'use client'

import { useEffect, useState } from 'react'
import Link from 'next/link'
import { Drone, ChevronRight } from 'lucide-react'

const SIGNUP_URL = '/auth/login'

export function NavBar() {
  const [solid, setSolid] = useState(false)

  useEffect(() => {
    const handle = () => setSolid(window.scrollY > 60)
    window.addEventListener('scroll', handle, { passive: true })
    return () => window.removeEventListener('scroll', handle)
  }, [])

  return (
    <nav
      aria-label="Navegação principal"
      style={{
        position: 'fixed',
        top: 0, left: 0, right: 0,
        zIndex: 100,
        padding: '14px 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: solid ? 'rgba(246,243,236,0.92)' : 'transparent',
        backdropFilter: solid ? 'blur(16px)' : 'none',
        WebkitBackdropFilter: solid ? 'blur(16px)' : 'none',
        borderBottom: solid ? '1px solid rgba(0,0,0,0.06)' : 'none',
        transition: 'all 0.3s ease',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
        <div
          style={{
            width: 34, height: 34,
            background: '#1A5C2E',
            borderRadius: 10,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          <Drone size={17} color="#fff" strokeWidth={2.2} />
        </div>
        <span
          style={{
            fontFamily: 'var(--font-bricolage)',
            fontWeight: 800,
            fontSize: 17,
            color: solid ? '#0A1A10' : '#fff',
            letterSpacing: '-0.025em',
            transition: 'color 0.3s ease',
          }}
        >
          DroneOps
        </span>
      </div>

      <Link
        href={SIGNUP_URL}
        style={{
          background: solid ? '#1A5C2E' : 'rgba(255,255,255,0.14)',
          border: solid ? 'none' : '1px solid rgba(255,255,255,0.22)',
          backdropFilter: solid ? 'none' : 'blur(8px)',
          color: '#fff',
          padding: '9px 18px',
          borderRadius: 50,
          fontSize: 13,
          fontWeight: 600,
          textDecoration: 'none',
          display: 'flex',
          alignItems: 'center',
          gap: 4,
          transition: 'all 0.3s ease',
        }}
      >
        Começar grátis
        <ChevronRight size={13} strokeWidth={2.5} />
      </Link>
    </nav>
  )
}
